module.exports = __webpack_public_path__ + "static/media/星地运动关系动力伺服平台.96a3a035.png";